import React, {Fragment } from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import Button from "@mui/material/Button";
import Invoice from "./Invoice";

export default function InvoicePrint({ invoice }) {
  const width = window.innerWidth;

  return (
    <Fragment>
      {width > 768 ? (
        <PDFViewer width="800" height="600" className="app">
          <Invoice invoice={invoice} />
        </PDFViewer>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PDFDownloadLink
            document={<Invoice invoice={invoice} />}
            fileName="Invoice Report Detail.pdf"
          >
            <Button
              variant="contained"
              style={{
                borderWidth: 1,
                borderRadius: 10,
              }}
            >
              Download file
            </Button>
          </PDFDownloadLink>
        </div>
      )}
    </Fragment>
  );
}
